<template>
    <v-dialog v-model="isVisible" persistent max-width="1000">
        <v-toolbar dark color="primary" >
            <v-icon>edit</v-icon>
            <v-toolbar-title class="white--text" >Edit Dashboard</v-toolbar-title>
                <v-spacer></v-spacer>

            <v-btn icon @click="close">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs
            v-model="tab"
            centered
            dark
            color="primary">
            <!-- <v-tab href="#tab-settings">
                Settings
            </v-tab> -->
            <v-tab href="#tab-layout">
                Layout
            </v-tab>
            <v-tab href="#tab-text">
                Text
            </v-tab>
            
        </v-tabs>
        <v-card >
            <v-card-text>
                <v-tabs-items v-model="tab">
                    <!-- <v-tab-item value="tab-settings">
                        <v-card >
                            sdaasdas
                        </v-card>
                    </v-tab-item> -->
                        <v-tab-item value="tab-layout">
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-form ref="form">
                                         <v-select
                                            :items="users"
                                             item-text="username"
                                            item-value="_id"
                                            v-model="dashboard.user"
                                            :menu-props="{ maxHeight: '400' }"
                                            label="Select"
                                            
                                            hint="Pick Users for this Dashboard"
                                            persistent-hint></v-select>
                                        <v-slider
                                            v-model="dashboard.settings.columns"
                                            hint="sasda"
                                            label="Dashboard columns"
                                            max="6"
                                            min="1"
                                            thumb-label="always"></v-slider>
                                    </v-form>
                                </v-flex>
                            </v-layout>
                    </v-tab-item>
                        <v-tab-item value="tab-text">
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <h3>Caption</h3>
                                    <v-text-field
                                        v-model="dashboard.settings.name.en"
                                        label="Caption english"></v-text-field>
                                    <v-text-field
                                        v-model="dashboard.settings.name.de"
                                        label="Caption german"></v-text-field>

                                    <h3>Description</h3>
                                    <v-text-field
                                        v-model="dashboard.settings.description.en"
                                        label="Description english"></v-text-field>
                                    <v-text-field
                                        v-model="dashboard.settings.description.de"
                                        label="Description german"></v-text-field>
                                </v-flex>
                            </v-layout>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapGetters } from 'vuex'


export default {
    props: {
        isVisible: {
            type: Boolean,
            required: true
        },
        dashboard: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters([
			'users'
		])
	},
    data() {
        return {
            tab: 'tab-layout',
            dashboardColumns: 3
        }
    },
	methods: {
        close () {
            this.$emit('close')
        }
	}
};
</script>
<style>

	.vue-grid-item.vue-grid-placeholder {
        background-color: rgb(53, 53, 53);
    }

    .widget-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
        transition: .5s ease;
        background: #464c69;
         /* filter:blur(4px);
        -o-filter:blur(4px);
        -ms-filter:blur(4px);
        -moz-filter:blur(4px);
        -webkit-filter:blur(4px); */
    }

    .widget-container:hover .widget-overlay {
        opacity: 0.8;
    }
</style>